<template>
  <div
    class="text-select-input"
    :class="[
      hasError ? 'text-select-input--error' : '',
      isSelected ? 'text-select-input--focus' : '',
    ]"
  >
    <div class="text-select-input__suffix">
      <span class="p-2">www.</span>
    </div>

    <v-text-field
      outlined
      :placeholder="placeholder"
      v-model="textComputed"
      class="v-input--md text-select-input__text-input"
      hide-details="auto"
      validate-on-blur
      :error-messages="errorsBag"
      :rules="internalRules"
      dense
      @focus="setFocus(true)"
      @blur="setFocus(false)"
      ref="text"
    ></v-text-field>

  </div>
</template>

<script>
export default {
  name: "DomainNameInput",
  props: {
    text: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    validate: function () {
      if (this.$refs.text) {
        return this.$refs.text.validate();
      }
      return true;
    },
    reset: function () {
      if (this.$refs.text) {
        this.$refs.text.reset();
      }
      this.hasError = false;
      this.errorsBag = [];
    },
    resetValidation: function () {
      if (this.$refs.text) {
        this.$refs.text.resetValidation();
      }
      this.hasError = false;
      this.errorsBag = [];
    },
    setFocus: function (value) {
      this.isSelected = value;
      if (!value) {
        this.$nextTick(() => {
          if (this.$refs.text) {
            this.hasError = !this.$refs.text.valid;
          }
        });
      }
    },
  },
  data: function () {
    return {
      isSelected: false,
      hasError: false,
      errorsBag: [],
    };
  },
  computed: {
    textComputed: {
      get: function () {
        return this.text;
      },
      set: function (newValue) {
        this.$emit("update:text", newValue);
        this.$emit(
          "update:value",
          newValue + this.suffix + this.selectComputed
        );
      },
    },
    internalRules: function () {
      return this.rules || [];
    },
  },
  watch: {
    text: {
      handler: function () {
        this.$nextTick(() => {
          if (this.$refs.text) {
            this.hasError = !this.$refs.text.valid;
          }
        });
      },
      immediate: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-select-input {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;

  .v-input::v-deep {
    &.v-text-flied {
      margin-bottom: 16px;
    }

    fieldset {
      border: none;
    }

    // Ukrycie obwódki błędu w Vuetify 2
    &.error--text .v-text-field__details {
      display: none;
    }

    &.error--text fieldset {
      border-color: transparent !important;
    }

    &.error--text .v-input__slot fieldset {
      border-color: transparent !important;
    }

    // Ukrycie obwódki w stanie focused z błędem
    &.error--text.v-input--is-focused .v-input__slot fieldset {
      border-color: transparent !important;
    }

    // Ukrycie obwódki dla outlined text field
    &.v-text-field--outlined.error--text .v-input__slot fieldset {
      border-color: transparent !important;
    }

    // Ukrycie hover state dla błędu
    &.error--text:hover .v-input__slot fieldset {
      border-color: transparent !important;
    }
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 46px;
    width: 100%;
    border-radius: 3px;
    pointer-events: none;
    transition: outline 0.24s ease, border 0.24s ease, width 0.24s ease,
    margin 0.24s ease;
  }

  &::before {
    border: 1px solid var(--v-gray-lighten2);
    z-index: 11;
  }

  &::after {
    border: 2px solid transparent;
    z-index: 10;
  }

  &:hover {
    &::before {
      border-color: transparent !important;
    }
    &::after {
      border: 1px solid map-get($primary, base);
    }
  }

  &--error {
    .v-input::v-deep {
      .v-input__icon--append {
        svg {
          color: map-get($error, base);
        }
      }
    }

    &::before {
      border-color: transparent !important;
    }

    &::after {
      border: 2px solid map-get($error, base);
    }
  }

  &--focus {
    .v-input::v-deep {
      .v-input__icon--append {
        svg {
          color: map-get($primary, base);
        }
      }
    }

    &::before {
      border-color: transparent !important;
    }

    &::after {
      border: 2px solid map-get($primary, base);
    }
  }

  &__text-input {
    display: flex;
  }

  &__suffix {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 69px;
    height: 46px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    background: var(--v-gray-lighten5);

    span {
      color: map-get($gray, darken1);
    }
  }
}
</style>